import React from "react";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";

const BMForbiddenSection = ({ routeData }) => {
  return (
    <div className="bm-forbidden-container">
      <div className="question-container">
        <img alt="" src={require("@/assets/images/404-question.svg")} />
        <div className="title">お探しのページはご利用できません</div>
        <div className="description">
          いつもTrynibusをご利用いただきありがとうございます。
          <br />
          あなたがアクセスしようとしたページは表示することが出来ませんでした。
          <br />
          ビジネスマッチング情報が閲覧できない状態に更新されているか、
          <br />
          アクセスが許可されていない場合があります。
        </div>
      </div>
      <Placeholder
        name="jss-contact"
        rendering={routeData}
        routeData={routeData}
      />
    </div>
  );
};

export default BMForbiddenSection;
